<template>
  <div :class="['wrapper', orderType || rejectOnly ? 'space-between' : '']">
    <div v-if="rejectOnly" class="reject-only-tip">系统判定该订单不符合接单条件，待人工审核拒单</div>
    <div v-else-if="orderType" class="score">
      <div
        class="item arbitrage-price"
        :style="{
          backgroundColor: getPrepayLevelColor(machinePrepayGrade),
        }"
      >
        <div>系统首付比</div>
        {{ formatPrepayRate(orderReviewV2.machinePrepayRate) }}
      </div>
      <div
        class="item arbitrage-price"
        :style="{
          backgroundColor: getPrepayLevelColor(orderReviewV2.finalPrepayGrade),
        }"
      >
        <div>最终首付比</div>
        {{ formatPrepayRate(orderReviewV2.finalPrepayRate) }}
      </div>
      <div class="item arbitrage-price">
        <div>套现空间</div>
        ￥{{ detailInfo.arbitragePrice }}
      </div>
    </div>

    <div class="submit-btn">
      <el-button v-if="!rejectOnly" type="" class="btn" size="middle" @click="submitResult(3)">
        取消
      </el-button>
      <el-button type="" class="btn" size="middle" @click="submitResult(2)">
        拒绝
      </el-button>
      <el-button
        v-if="rejectOnly"
        type="primary"
        plain
        size="middle"
        @click="$emit('manual-intervention')"
      >
        人工介入
      </el-button>
      <el-button v-if="!rejectOnly" type="primary" size="middle" @click="submitResult(1)">
        同意
      </el-button>
    </div>
  </div>
</template>

<script>
import { getPrepayLevelColor, getPrepayLevelByRate } from "@/enum/dict";

export default {
  name: "AuditResult",
  props: {
    rejectOnly: Boolean,
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 读取首付比审核结果。
    orderReviewV2() {
      return this.detailInfo.orderReviewV2 || {};
    },
    // 系统首付比对应的档位只用于配色。
    machinePrepayGrade() {
      return (
        getPrepayLevelByRate(this.orderReviewV2.machinePrepayRate)?.name || ""
      );
    },
    // 门店订单展示首付比审核结果。
    orderType() {
      const orderType = this.$route.query.orderType;
      return orderType == 2 || orderType == 4;
    },
  },
  methods: {
    // 未知档位使用中性灰，避免露出套现空间卡片的红色。
    getPrepayLevelColor,
    // 缺失首付比时显示占位符。
    formatPrepayRate(rate) {
      return rate === null || rate === undefined || rate === ""
        ? "--"
        : String(rate) + "%";
    },
    // 校验通过后通知父页面处理审核提交。
    submitResult(val) {
      if (this.orderType && !this.orderReviewV2.finalPrepayGrade && val == 1) {
        this.$alert("用户评级不能为空", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
      this.$emit("result", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .reject-only-tip {
    flex: 1;
    padding-right: 20px;
    color: #f5222d;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.5;
  }

  .score {
    display: flex;
    align-items: center;
    .item {
      color: #fff;
      border-radius: 4px;
      margin-right: 20px;
      font-size: 14px;
      padding: 5px 10px;
    }
  }
  .submit-btn {
    text-align: right;
    .btn {
      background: #f2f3f5;
      color: #666666;
      border: none;
    }
    .el-button {
      border: none;
    }
  }
}
.space-between {
  justify-content: space-between;
}
.arbitrage-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 52px;
  min-width: 130px;
  padding: 5px 10px;
  background-color: #d05252;
}
</style>
